import { createContext, useContext } from 'react';
import type { IBondScreenerView } from '@/creditflowresearch/domain/vo/Bondscreener';

export interface IBondScreenerViewsContextValue {
  views: IBondScreenerView[],
  activeViewId: string | null,
  activeView: IBondScreenerView | null,
  selectView: (viewId: string | null) => void,
  selectAndApplyView: (viewId: string | null) => void,
  commitActiveView: (viewId: string | null) => void,
  discardActiveView: () => void,
  saveActiveView: () => Promise<void>,
  saveAsNewView: (name: string) => Promise<void>,
  renameActiveView: (name: string) => Promise<void>,
  deleteActiveView: () => Promise<void>,
  canSaveActiveView: boolean,
  canCreateView: boolean,
}

export const BondScreenerViewsContext = createContext<IBondScreenerViewsContextValue | null>(null);

export const useBondScreenerViewsContext = (): IBondScreenerViewsContextValue => {
  const context = useContext(BondScreenerViewsContext);

  if (!context) {
    throw new Error('useBondScreenerViewsContext must be used within a bond screener views provider');
  }

  return context;
};
